import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../../hooks/useQueryRequestParams';
import envVars from '../../../../constants/envVars';
const usePrepareDeviceLogs = () => {
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.post(`${envVars.API_CLOUD_HOSTNAME}backoffice/logs-on-demand/request/`, attributes, params),
        onSuccess: () => { }
    });
};
export default usePrepareDeviceLogs;
